module.exports = __webpack_public_path__ + "static/media/email-final.3a7c02a6.svg";